import GlassCard from "../components/GlassCard";

const stats = [
  { number: "1.5+", label: "Years Experience" },
  { number: "9+", label: "Certifications" },
  { number: "3+", label: "AI Systems Built" },
  { number: "100+", label: "Students Mentored" },
];

const Stats = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 py-10 grid grid-cols-2 md:grid-cols-4 gap-6">
      {stats.map((stat, index) => (
        <GlassCard key={index}>
          <div className="text-center">
            <h2 className="text-3xl font-bold text-cyan-400">{stat.number}</h2>
            <p className="text-gray-300 mt-2">{stat.label}</p>
          </div>
        </GlassCard>
      ))}
    </div>
  );
};

export default Stats;